import React, { useState, useEffect } from "react";
import styles from "./../../assets/styles/_productDetail.module.scss";
import imgContent1 from "./../../assets/images/products/imgContent1.png";
import img1Content1 from "./../../assets/images/products/img1Content1.png";
import img2Content1 from "./../../assets/images/products/img2Content1.png";
// import img3Content1 from "./../../assets/images/products/img3Content1.png";
import imgContent2 from "./../../assets/images/products/imgContent2.png";
import img1Content2 from "./../../assets/images/products/img1Content2.png";
import img2Content2 from "./../../assets/images/products/img2Content2.png";
// import img3Content2 from "./../../assets/images/products/img3Content2.png";
// import img4Content2 from "./../../assets/images/products/img4Content2.png";
import thumbProduct from "../../assets/images/productPage/product-bottle.png";
import thumbProduct1 from "../../assets/images/productPage/product-bottle1.png";
import thumbProduct2 from "../../assets/images/productPage/product-bottle2.png";
import thumbProduct3 from "../../assets/images/productPage/product-bottle3.png";
// import thumbProduct4 from "../../assets/images/productPage/product-bottle4.png";
// import thumbProduct5 from "../../assets/images/productPage/product-bottle5.png";
import warnning from "../../assets/images/products/warnning.png";
import banner from "../../assets/images/products/banner.webp";
import bannerMB from "../../assets/images/products/bannerMB.webp";
import FadeInSection from "../common/FadeInSection";
import Breadcrumb from "../common/breadcrum";
import Slider from "react-slick"; // Import thư viện react-slick
import { deepItems } from "./productDetails";
import ECModal from "../common/ECModal";

const ProductDetailComponent = () => {
  const data = deepItems;

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [ecLinks, setEcLinks] = useState({});
  const ShowModal = (ecLink) => {
    setEcLinks(ecLink);
    setShowModal(true);
  };

  const moist = [
    {
      id: 1,
      thumb: imgContent1,
      title1: "セラミド",
      desc1:
        "髪や頭皮の保湿をサポートし、うるおいを保つ成分です。乾燥やダメージから髪を守り、なめらかで健やかな状態へ導きます。",
      desc2:
        "＜シャンプー・トリートメント＞<br />セラミドNG、セラミドAP、セラミドAG、セラミドNP、セラミドEOP（全て保湿成分）<br />＜ヘアオイル・ヘアミルク＞<br />セラミドNG、セラミドAP、セラミドNP、セラミドEOP（全て保湿成分）",
    },
    {
      id: 2,
      thumb: img1Content1,
      title1: "アボカドオイル",
      desc1:
        "ビタミンEや脂肪酸など豊富な栄養素を含む植物由来のオイルです。髪や頭皮に潤いを与え、乾燥やダメージを防ぐとともに、髪のしなやかさとツヤをサポートします。髪への浸透性が高いため、軽やかな使い心地でベタつかず、髪の毛一本一本を保護しながら健康な髪へ導きます。",
      desc2: "*2　アボカド油（保湿成分）",
    },
    {
      id: 3,
      thumb: img2Content1,
      title1: "ラノリン",
      desc1:
        "羊毛から得られる毛髪の皮脂と似た構造を持つ天然の保湿成分です。しっとりとした柔らかい髪へと導き、パサつきや広がりを抑え、まとまりやすい状態に整えます。また、髪の表面をコーティングし、ダメージから守る役割を果たします。",
      desc2:
        "＜シャンプー・トリートメント＞<br />液状ラノリン（保湿成分）<br />＜ヘアオイル・ヘアミルク＞<br />ラノリン（羊毛）（保湿成分）",
    },
  ];

  const steps = [
    {
      id: 1,
      thumb: thumbProduct,
      title: "STEP 01",
      span: "シャンプー",
      desc: "太髪の方でもゴワつかず洗えるよう軽くなめらかな泡立ちです",
    },
    {
      id: 2,
      thumb: thumbProduct1,
      title: "STEP 02",
      span: "トリートメント",
      desc: "太い髪にスッと馴染む伸びの良いテクスチャーで洗い流すとしっとりまとまる仕上がりです",
    },
    {
      id: 3,
      thumb: thumbProduct3,
      title: "STEP 03",
      span: "ヘアミルク",
      desc: "水分と油分を含んだ濃厚なテクスチャーで乾燥した毛先を柔らかくまとめます",
    },
    {
      id: 4,
      thumb: thumbProduct2,
      title: "STEP 04",
      span: "ヘアオイル",
      desc: "さらさらしたテクスチャーでゴワつき広がる髪を指通りの良いツヤ髪へと仕上げます",
    },
  ];

  const instructs = [
    {
      title: "シャンプー",
      items: [
        {
          id: 1,
          desc: "38℃程度のお湯でしっかりと予洗いをして髪と地肌をよく濡らす",
        },
        {
          id: 2,
          desc: "適量を手にとり、泡立ててから髪に塗布する",
          adjust: [
            {
              id: 1,
              title: "ショート",
              cout: "1~2",
              volume: "(3〜6mL)",
            },
            {
              id: 2,
              title: "ミディアム",
              cout: "2~3",
              volume: "(6〜9mL)",
            },
            {
              id: 3,
              title: "ロング",
              cout: "3~4",
              volume: "(9〜12mL)",
            },
          ],
        },
        {
          id: 3,
          desc: "泡立てながら地肌をマッサージするように洗う",
        },
        {
          id: 4,
          desc: "十分にお湯ですすぐ ",
        },
      ],
    },
    {
      title: "トリートメント",
      items: [
        {
          id: 1,
          desc: "シャンプー後、髪の水気をきる",
        },
        {
          id: 2,
          desc: "適量を手のひらに取って伸ばし、毛先中心に塗布する",
          adjust: [
            {
              id: 1,
              title: "ショート",
              cout: "1~2",
              volume: "(3〜6g)",
            },
            {
              id: 2,
              title: "ミディアム",
              cout: "2~3",
              volume: "(6〜9g)",
            },
            {
              id: 3,
              title: "ロング",
              cout: "3~4",
              volume: "(9〜12g)",
            },
          ],
        },
        {
          id: 3,
          desc: "髪にもみこみ、十分になじませる",
        },
        {
          id: 4,
          desc: "ぬめり感がなくなる程度にお湯ですすぐ ",
        },
      ],
    },
    {
      title: "ヘアミルク",
      items: [
        {
          id: 1,
          desc: "濡れた髪をタオルドライする",
        },
        {
          id: 2,
          desc: "適量を手に取って毛先を中心になじませる",
          adjust: [
            {
              id: 1,
              title: "ショート",
              cout: "1",
              volume: "1g",
            },
            {
              id: 2,
              title: "ミディアム",
              cout: "2",
              volume: "2g",
            },
            {
              id: 3,
              title: "ロング",
              cout: "3",
              volume: "3g",
            },
          ],
        },
        {
          id: 3,
          desc: "ドライヤーで髪を乾かす",
        },
      ],
    },
    {
      title: "ヘアオイル",
      items: [
        {
          id: 1,
          desc: "濡れた髪をタオルドライする",
        },
        {
          id: 2,
          desc: "適量を手に取って毛先を中心になじませる",
          adjust: [
            {
              id: 1,
              title: "ショート",
              cout: "1",
              volume: "1g",
            },
            {
              id: 2,
              title: "ミディアム",
              cout: "2",
              volume: "2g",
            },
            {
              id: 3,
              title: "ロング",
              cout: "3",
              volume: "3g",
            },
          ],
        },
        {
          id: 3,
          desc: "ドライヤーで髪を乾かす",
          note: "*ヘアミルクと併用される際は、濡れた髪にヘアミルクを塗布してドライヤーで半分程度髪を乾かしてからヘアオイルを塗布し、乾かすことがおすすめです。",
        },
      ],
    },
  ];
  const isMobile = window.innerWidth < 576;
  const settings = {
    infinite: false, // Lặp lại vô hạn
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <div className={`${styles.productDetail} ${styles.deep}`}>
      <div className={styles.bgrProductDetailPage}></div>
      <FadeInSection>
        <div className={styles.banner}>
          <img src={isMobile ? bannerMB : banner} alt="banner" />
        </div>
        <div className={styles.heightBanner}></div>
        <div className={styles.headContent}>
          <div className={styles.top}>myO2 WATER COAT</div>
          <div className={styles.title}>
            <p>
              SHAMPOO<span>&</span>
            </p>
            <p>TREATMENT </p>
            <p>
              HAIR MILK<span>&</span>
            </p>
            <p>HAIR OIL </p>
          </div>
          <div className={styles.descHead}>
            マイ・オーツーウォーターコート {isMobile ? <br /> : ""}
            ディープモイスト
            <br />
            【ホワイトフローラルエアーの香り】
          </div>
          <div className={styles.note}>
            美容酸素水※ + ディープモイストエッセンスで、
            <br />
            パサつき、うねり、毛先広がる太髪に、
            {isMobile ? <br /> : ""}
            うるおいとまとまりを与え、毛先つるん髪へ
          </div>
          <div className={styles.note}>
            ＜シャンプー・トリートメント・ヘアミルク＞
            <br />
            ※水、酸素、乳酸桿菌／加水分解コラーゲン発酵液エキス、ヒアルロン酸Na、ヒアルロン酸ヒドロキシプロピルトリモニウムの複合成分（全て保湿成分）
            <br />
            ＜ヘアオイル＞
            <br />
            ※水、酸素、イソステアロイル加水分解コラーゲンAMPD、ヒアルロン酸Naの複合成分（全て保湿成分）
          </div>
        </div>
      </FadeInSection>
      <div className={styles.productList}>
        <FadeInSection>
          <div className={styles.title}>ご購入はこちら</div>
          <div className={styles.btnList}>
            <div className={styles.btnItem}>ALL</div>
            <div className={styles.btnItem}>セット</div>
            <div className={styles.btnItem}>単品</div>
            <div className={styles.btnItem}>詰め替え</div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className={styles.list}>
            {data.map((item, index) => (
              <div className={styles.item} key={index}>
                <div className={styles.thumb}>
                  <img src={item.thumb} alt="product" />
                </div>
                <div
                  className={styles.title}
                  dangerouslySetInnerHTML={{ __html: item.title1 }}
                ></div>
                <div className={styles.title}>{item.title2}</div>
                <div className={styles.endItem}>
                  {item.price}
                  <span>
                    円(税込)<div className={styles.volume}>{item.volume}</div>
                  </span>
                </div>
                <button
                  className={styles.btnNext}
                  onClick={() => ShowModal(item.ecLink)}
                >
                  <p>購入する</p>
                </button>
              </div>
            ))}
          </div>
        </FadeInSection>
      </div>
      <FadeInSection>
        <div className={`${styles.ingredient} ${styles.right}`}>
          <div className={styles.bgr}></div>
          <div className={styles.title}>
            ディープモイスト{isMobile ? <br /> : ""}エッセンス
          </div>
          <div className={styles.list}>
            {moist.map((item, index) => (
              <div className={styles.item} key={index}>
                <div className={styles.thumb}>
                  <img src={item.thumb} alt="product" />
                </div>
                <div className={styles.content}>
                  <div className={styles.titleContent}>
                    {item.title1} <span>*{item.id}</span>
                  </div>
                  <div className={styles.desc1}>{item.desc1}</div>
                  <div
                    className={styles.desc2}
                    dangerouslySetInnerHTML={{ __html: item.desc2 }}
                  ></div>
                </div>
                <div
                  className={styles.vector}
                  style={{
                    display: index === moist.length - 1 ? "none" : "block",
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      </FadeInSection>
      <FadeInSection>
        <div className={styles.titleProductDetail}>
          <div className={styles.title}>心にうるおいめぐる</div>
          <div className={styles.title2}>ビューティーフレグランス</div>
        </div>
        <div className={`${styles.ingredient} ${styles.left}`}>
          <div className={styles.bgr}></div>
          <div className={styles.titleDeepMoist}>
            <div className={styles.topTitle}>DEEP MOIST</div>
            <div className={styles.descTitle}>
              洗練された
              <br className={styles.hide} />
              ホワイトフローラルエアーの香り
            </div>
          </div>
          <div className={styles.list}>
            <div className={`${styles.itemTop} ${styles.item}`}>
              <div className={styles.content}>
                <div className={styles.title1}>TOP</div>
                <div className={styles.desc1}>
                  ベルガモット、{isMobile ? <br /> : ""}カシス、アップル
                </div>
              </div>
              <div className={styles.thumb}>
                <img src={imgContent2} alt="product" />
              </div>
            </div>
            <div className={`${styles.itemMiddle} ${styles.item}`}>
              <div className={styles.content}>
                <div className={styles.title1}>MIDDLE</div>
                <div className={styles.desc1}>
                  ミュゲ、{isMobile ? <br /> : ""}ライラック、ローズ
                </div>
              </div>
              <div className={styles.thumb}>
                <img src={img1Content2} alt="product" />
              </div>
            </div>
            <div className={`${styles.itemLast} ${styles.item}`}>
              <div className={styles.content}>
                <div className={styles.title1}>LAST</div>
                <div className={styles.desc1}>
                  アンバー、ムスク、{isMobile ? <br /> : ""}サンダルウッド
                </div>
              </div>
              <div className={styles.thumb}>
                <img src={img2Content2} alt="product" />
              </div>
            </div>
          </div>
        </div>
      </FadeInSection>
      <FadeInSection>
        <div className={styles.step}>
          <div className={styles.title}>STEP</div>
          <div className={styles.noteTitle}>
            <div className={styles.item}>
              <p>シャンプー</p>
              <p className={styles.down}>↓</p>
              <p className={styles.right}>→</p>
              <p>トリートメント</p>
              <p className={styles.right}>→</p>
              <p className={styles.down}>↓</p>
              <p>ヘアミルク</p>
              <p className={styles.right}>→</p>
              <p className={styles.down}>↓</p>
              <p>ヘアオイル</p>
            </div>
          </div>
          <div className={styles.steps}>
            {steps.map((item, index) => (
              <div className={styles.item} key={index}>
                <div className={styles.thumb}>
                  <div className={styles.vectorPrevios}></div>
                  <img src={item.thumb} alt="product" />
                  <div
                    className={styles.vector}
                    style={{
                      display: index === steps.length - 1 ? "none" : "flex",
                    }}
                  ></div>
                </div>
                <div className={styles.content}>
                  <div className={styles.titleContent}>
                    {item.title}
                    <span>{item.span}</span>
                  </div>
                  <div className={styles.desc}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div className={`${styles.stepsTl} ${styles.steps}`}>
            <Slider {...settings}>
              {steps.map((item, index) => (
                <div className={styles.item}>
                  <div className={styles.thumb}>
                    {/* <div
                      className={styles.vectorPrevios}
                      style={{ opacity: index === 0 ? 0 : 1 }}
                    ></div> */}
                    <img src={item.thumb} alt="product" />
                    <div
                      className={styles.vector}
                      style={{ opacity: index === steps.length - 1 ? 0 : 1 }}
                    ></div>
                  </div>
                  <div className={styles.content}>
                    <div className={styles.titleContent}>
                      {item.title}
                      <span>{item.span}</span>
                    </div>
                    <div className={styles.desc}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </FadeInSection>
      <FadeInSection>
        <div className={styles.instruct}>
          <div className={styles.title}>ご使用方法</div>
          <div className={styles.noteTitle}>
            【シャンプー・トリートメントの開け方】
          </div>
          <div className={styles.descTitle}>
            ポンプ首部を押さえながら頭部を左に回して上げ、数回空押ししてからご使用ください。
          </div>
          <div className={styles.instructs}>
            {instructs.map((instruct, index) => (
              <div className={styles.item} key={index}>
                <div className={styles.instructTitle}>{instruct.title}</div>
                <div className={styles.content}>
                  {instruct.items.map((item) => (
                    <div className={styles.itemContent} key={item.id}>
                      <div className={styles.desc}>
                        <div className={styles.stt}>0{item.id}</div>
                        <div className={styles.note}>{item.desc}</div>
                      </div>
                      {item.adjust && (
                        <div className={styles.adjusts}>
                          {item.adjust.map((adjust, idx) => (
                            <div className={styles.adjust} key={idx}>
                              <div className={styles.titleAdjust}>
                                {adjust.title}
                              </div>
                              <div className={styles.adjustContent}>
                                <div className={styles.cout}>{adjust.cout}</div>
                                <div className={styles.descAdjust}>
                                  プッシュ
                                </div>
                                <div className={styles.volume}>
                                  {adjust.volume}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {item.note && (
                        <div className={styles.noteItem}>{item.note}</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </FadeInSection>
      <FadeInSection>
        <div className={styles.warnning}>
          <div className={styles.warnningIcon}>
            <img src={warnning} />
          </div>
          <div className={styles.warnningDesc}>
            【ご使用上の注意】●お肌に異常が生じていないかよく注意して使用してください。●お肌に合わないとき即ち次のような場合には、使用を中止してください。そのまま使用を続けますと、症状を悪化させることがありますので、皮フ科専門医等にご相談されることをおすすめします。(1)使用中、赤味、はれ、かゆみ、刺激等の異常があらわれた場合(2)使用したお肌に、直射日光があたって上記のような異常があらわれた場合●傷やはれもの、しっしん等、異常のある部位には使用しないでください。●目に入らないよう注意し、入ったときはすぐに洗い流してください。目に異物感が残る場合は、眼科医にご相談ください。●開封後はなるべく早く使い切るようにしてください。●乳幼児の手の届かないところに保管してください。●極端に低温または高温な場所、直射日光の当たる場所には保管しないでください。●ノズル先端で中身が固まり、強く押した際に液体が飛び出す場合がありますのでご注意ください。●天然由来成分を配合しているため、まれに色・香りが変化する場合がありますが品質に問題はありません。
          </div>
        </div>
      </FadeInSection>
      <div className={`${styles.productList}  ${styles.listMb}`}>
        <FadeInSection>
          <div className={styles.title}>ご購入はこちら</div>
          <div className={styles.btnList}>
            <div className={styles.btnItem}>ALL</div>
            <div className={styles.btnItem}>セット</div>
            <div className={styles.btnItem}>単品</div>
            <div className={styles.btnItem}>詰め替え</div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className={styles.list}>
            {data.map((item, index) => (
              <div className={styles.item} key={index}>
                <div className={styles.thumb}>
                  <img src={item.thumb} alt="product" />
                </div>
                <div
                  className={styles.title}
                  dangerouslySetInnerHTML={{ __html: item.title1 }}
                ></div>
                <div className={styles.title}>{item.title2}</div>
                <div className={styles.endItem}>
                  {item.price}
                  <span>
                    円(税込)<div className={styles.volume}>{item.volume}</div>
                  </span>
                </div>
                <button
                  className={styles.btnNext}
                  onClick={() => ShowModal(item.ecLink)}
                >
                  <p>購入する</p>
                </button>
              </div>
            ))}
          </div>
        </FadeInSection>
      </div>
      <Breadcrumb
        data={[
          {
            title: "TOP",
            link: "/",
          },
          {
            title: "PRODUCT",
            link: "/products",
          },
          {
            title: "DEEP MOIST",
            link: "/productDetail",
          },
        ]}
      />
      <ECModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        ecLinks={ecLinks}
      ></ECModal>
    </div>
  );
};

export default ProductDetailComponent;
